<template>
  <div class="container">
    <div class="userInfo">
      <el-card class="box-card account-card">
        <div slot="header" class="account-card-header">
          <h2>账号信息</h2>
          <el-tag size="small" :type="userInfo.individual === 1 ? 'success' : 'primary'">
            {{ userInfo.individual === 1 ? '个人账号' : '单位账号' }}
          </el-tag>
        </div>
        <div class="account-info-body">
          <div class="account-info-row">
            <span class="account-info-label">手机号</span>
            <div class="account-info-content">
              <span class="account-info-value">{{ userInfo.name || '—' }}</span>
              <el-button type="text" class="account-action-btn" @click="buttonChange()">修改</el-button>
            </div>
          </div>
          <div class="account-info-row">
            <span class="account-info-label">{{ userInfo.individual === 1 ? '姓名' : '单位名' }}</span>
            <div class="account-info-content">
              <span class="account-info-value">{{ userInfo.companyName || '—' }}</span>
            </div>
          </div>
          <div class="account-info-row account-info-row-license">
            <span class="account-info-label">{{ userInfo.individual === 1 ? '身份证' : '营业执照' }}</span>
            <div class="account-info-content">
              <div v-if="userInfo.businessLicense" class="account-license-box">
                <div class="account-license-preview" @click="previewLicense()">
                  <img
                      :src="getLicenseUrl(userInfo.businessLicense)"
                      :alt="userInfo.individual === 1 ? '身份证' : '营业执照'"
                      class="account-license-img"
                  />
                </div>
                <el-button type="text" class="account-action-btn" @click="previewLicense()">
                  <i class="el-icon-zoom-in"></i> 查看大图
                </el-button>
              </div>
              <span v-else class="account-info-empty">—</span>
            </div>
          </div>
        </div>
      </el-card>
    </div>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <h2>审核数据</h2>
      </div>
      <div class="tabBox">
        <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
          <el-tab-pane label="审核通过" name="first">
            <div class="search-box">
              <div class="search-item">
                <label>成果名称：</label>
                <el-input
                    v-model="achievementName"
                    placeholder="请输入成果名称进行查询"
                    clearable
                    style="width: 300px;"
                />
              </div>
              <div class="search-buttons">
                <el-button type="primary" @click="filterByPhoneNumber(2)">查询</el-button>
                <el-button @click="resetSearch(2)">重置</el-button>
              </div>
            </div>
            <div class="itemBox" v-if="passReview.length">
              <el-table :data="passReview" border style="width: 100%">
                <el-table-column prop="createTime" label="日期" align="center">
                </el-table-column>
                <el-table-column prop="achievementName" label="成果名称" align="center">
                </el-table-column>
                <el-table-column prop="holdingUnit" label="持有单位/人" align="center">
                </el-table-column>
                <el-table-column prop="completionUnit" label="完成单位/人" align="center">
                </el-table-column>
                <el-table-column prop="certificateNo" label="证书编号" align="center">
                </el-table-column>
                <el-table-column prop="hashValue" label="哈希值" align="center">
                </el-table-column>
                <el-table-column prop="phoneNumber" label="手机号" align="center">
                </el-table-column>
                <el-table-column prop="userName" label="提交账号" align="center">
                </el-table-column>
                <el-table-column prop="certificateUrl" label="证书" align="center">
                  <template #default="scope">
                    <el-link
                        type="primary"
                        :href="scope.row.certificateUrl"
                        target="myTab"
                        :underline="false"
                    >
                      查看
                    </el-link>
                  </template>
                </el-table-column>
                <el-table-column prop="certificateUrl" label="资料" align="center">
                  <template #default="scope">
                    <el-button
                        type="primary"
                        size="small"
                        :loading="scope.row.downloading"
                        @click="handleDownload(scope.row)"
                    >
                      {{ scope.row.downloading ? '下载中...' : '下载' }}
                    </el-button>
                  </template>
                </el-table-column>
                <el-table-column label="转化详情" align="left" min-width="220">
                  <template #default="scope">
                    <el-link
                        type="primary"
                        target="_blank"
                        :underline="false"
                        @click="evidenceById(scope.row.id)"
                    >
                      查看
                    </el-link>
                    <br><br>
                    <div v-if="getExclusiveTransferDetail(scope.row)" class="transfer-detail-cell">
                      <div>{{ getExclusiveTransferDetail(scope.row).label }}</div>
                      <div v-if="getExclusiveTransferDetail(scope.row).time && getExclusiveTransferDetail(scope.row).time !== '—'">
                        时间：{{ getExclusiveTransferDetail(scope.row).time }}
                      </div>
                    </div>
                    <div v-else-if="getTransferDetail(scope.row)" class="transfer-detail-cell">
                      <div v-if="getTransferDetail(scope.row).pending" class="transfer-detail-pending">转化审核中</div>
                      <div>成果：{{ getTransferDetail(scope.row).achievementName }}</div>
                      <div>时间：{{ getTransferDetail(scope.row).time }}</div>
                      <div>{{ getTransferDetail(scope.row).description }}</div>
                      <div>转化类型：{{ getTransferDetail(scope.row).transferTypeLabel }}</div>
                    </div>
                    <el-link
                        v-else-if="canDisposeAchievement(scope.row)"
                        type="primary"
                        :underline="false"
                        @click="openModal(scope.row)"
                    >
                      转化
                    </el-link>
                    <span v-else>—</span>
                  </template>
                </el-table-column>
              </el-table>
              <el-pagination
                  @size-change="handleSizeChangeFirst"
                  @current-change="handleCurrentChangeFirst"
                  :page-sizes="[1,10, 20, 50, 100]"
                  :page-size="pageSizeFist"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="total"
                  class="pageList"/>
            </div>
            <div class="itemBox" v-else>
              <div class="empty">
                <img src="@/assets/img/noUser.png" alt="" class="noData"/>
                <div class="emptyText">暂无数据</div>
              </div>
            </div>

          </el-tab-pane>
          <el-tab-pane label="审核失败" name="second">
            <div class="search-box" style="margin-bottom: 20px;">
              <span style="margin-right: 10px;">成果名称：</span>
              <el-input
                  v-model="achievementName"
                  placeholder="请输入成果名称进行查询"
                  clearable
                  style="width: 300px;"
              ></el-input>
              <el-button type="primary" @click="filterByPhoneNumber(1)">查询</el-button>
              <!-- 重置按钮 -->
              <el-button @click="resetSearch(1)" style="margin-left: 10px;">重置</el-button>
            </div>
            <div class="itemBox" v-if="underReview.length">
              <el-table :data="underReview" border style="width: 100%">
                <el-table-column prop="createTime" label="失败时间
" align="center">
                </el-table-column>
                <el-table-column prop="achievementName" label="成果名称" align="center">
                </el-table-column>
                <el-table-column prop="holdingUnit" label="持有单位/人" align="center">
                </el-table-column>
                <el-table-column prop="completionUnit" label="完成单位/人" align="center">
                </el-table-column>
<!--                <el-table-column prop="certificateNo" label="证书编号" align="center">-->
<!--                </el-table-column>-->
                <el-table-column prop="phoneNumber" label="手机号" align="center">
                </el-table-column>
                <el-table-column prop="userName" label="提交账号" align="center">
                </el-table-column>
<!--                <el-table-column prop="certificateUrl" label="证书" align="center">-->
<!--                  <template #default="scope">-->
<!--                    <el-link-->
<!--                        type="primary"-->
<!--                        :href="scope.row.certificateUrl"-->
<!--                        target="myTab"-->
<!--                        :underline="false"-->
<!--                    >-->
<!--                      查看-->
<!--                    </el-link>-->
<!--                  </template>-->
<!--                </el-table-column>-->

                <el-table-column prop="certificateUrl" label="资料" align="center">
                  <template #default="scope">
                    <el-button
                        type="primary"
                        size="small"
                        :loading="scope.row.downloading"
                        @click="handleDownload(scope.row)"
                    >
                      {{ scope.row.downloading ? '下载中...' : '下载' }}
                    </el-button>
                  </template>
                </el-table-column>
                <el-table-column label="详情" align="center" min-width="160">
                  <template #default="scope">
                    <el-link
                        type="primary"
                        :underline="false"
                        @click="evidenceById(scope.row.id)"
                    >
                      查看
                    </el-link>
                    <el-link
                        v-if="Number(scope.row.auditStatus) === 1"
                        type="primary"
                        :underline="false"
                        style="margin-left: 8px;"
                        @click="editEvidence(scope.row)"
                    >
                      修改并重新提交
                    </el-link>
                  </template>
                </el-table-column>
              </el-table>
              <el-pagination
                  @size-change="handleSizeChangeTwo"
                  @current-change="handleCurrentChangeTwo"
                  :page-sizes="[1,10, 20, 50, 100]"
                  :page-size="pageSizeTwo"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="total"
                  class="pageList"/>
            </div>
            <div class="itemBox" v-else>
              <div class="empty">
                <img src="@/assets/img/noUser.png" alt="" class="noData"/>
                <div class="emptyText">暂无数据</div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="审核中" name="third">
            <div class="search-box" style="margin-bottom: 20px;">
              <span style="margin-right: 10px;">成果名称：</span>
              <el-input
                  v-model="achievementName"
                  placeholder="请输入成果名称进行查询"
                  clearable
                  style="width: 300px;"
              ></el-input>
              <el-button type="primary" @click="filterByPhoneNumber(0)">查询</el-button>
              <!-- 重置按钮 -->
              <el-button @click="resetSearch(0)" style="margin-left: 10px;">重置</el-button>
            </div>
            <div class="itemBox" v-if="pendingReview.length">
              <!--              {{pendingReview}}-->
              <el-table :data="pendingReview" border style="width: 100%">
                <el-table-column prop="createTime" label="提交时间" align="center">
                </el-table-column>
                <el-table-column prop="achievementName" label="成果名称" align="center">
                </el-table-column>
                <el-table-column prop="holdingUnit" label="持有单位/人" align="center">
                </el-table-column>
                <el-table-column prop="completionUnit" label="完成单位/人" align="center">
                </el-table-column>
                <el-table-column prop="phoneNumber" label="手机号" align="center">
                </el-table-column>
                <el-table-column prop="userName" label="提交账号" align="center">
                </el-table-column>
                <el-table-column prop="certificateUrl" label="资料" align="center">
                  <template #default="scope">
                    <el-button
                        type="primary"
                        size="small"
                        :loading="scope.row.downloading"
                        @click="handleDownload(scope.row)"
                    >

                      {{ scope.row.downloading ? '下载中...' : '下载' }}
                    </el-button>
                  </template>
                </el-table-column>
                <el-table-column label="操作" align="center" v-if="showAdmin">
                  <template #default="scope">
                    <div class="button-group">
                      <button class="custom-buttonPass " @click="handleApprove(scope.row)">通过</button>
                      <button class="custom-buttonRefuse" @click="handleReject(scope.row)">拒绝</button>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="详情" align="center" min-width="80">
                  <template #default="scope">
                    <el-link
                        type="primary"
                        :underline="false"
                        @click="evidenceById(scope.row.id)"
                    >
                      查看
                    </el-link>
                  </template>
                </el-table-column>
              </el-table>
              <el-pagination
                  @size-change="handleSizeChangeThree"
                  @current-change="handleCurrentChangeThree"
                  :page-sizes="[1,10, 20, 50, 100]"
                  :page-size="pageSizeThree"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="total"
                  class="pageList"/>
            </div>
            <div class="itemBox" v-else>
              <div class="empty">
                <img src="@/assets/img/noUser.png" alt="" class="noData"/>
                <div class="emptyText">暂无数据</div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="转化列表" name="four">
            <div class="search-box">
              <div class="search-item">
                <label>成果名称：</label>
                <el-input
                    v-model="achievementName"
                    placeholder="请输入成果名称进行查询"
                    clearable
                    style="width: 300px;"
                />
              </div>
              <div class="search-buttons">
                <el-button type="primary" @click="getAchievementList()">查询</el-button>
                <el-button @click="resetTransfer()">重置</el-button>
              </div>
            </div>
            <div class="itemBox" v-if="achievementTransfersList.length">
              <el-table :data="achievementTransfersList" border style="width: 100%">
                <el-table-column prop="fromUserName" label="转让人" align="center">
                </el-table-column>
                <el-table-column prop="achievementName" label="成果" align="center">
                </el-table-column>
                <el-table-column prop="toUserName" label="接收人" align="center">
                </el-table-column>
                <el-table-column prop="receiveName" label="持有单位/人" align="center">
                </el-table-column>
                <el-table-column prop="receivePhone" label="联系电话" align="center">
                </el-table-column>
                <el-table-column prop="uploadAgreementFile" label="转化协议" align="center" width="80">
                  <template #default="scope">
                    <el-link
                        v-if="scope.row.uploadAgreementFile"
                        type="primary"
                        :underline="false"
                        @click="openAgreementFile(scope.row.uploadAgreementFile)"
                    >
                      查看
                    </el-link>
                    <span v-else>—</span>
                  </template>
                </el-table-column>
                <el-table-column prop="receiveMoney" label="转化金额" align="center" width="100">
                </el-table-column>
                <el-table-column prop="transferType" label="转化类型" align="center" width="110">
                  <template #default="scope">
                    {{ formatTransferTypeLabel(scope.row.transferType) }}
                  </template>
                </el-table-column>
                <el-table-column prop="transferTime" label="转化时间" align="center" width="110">
                  <template #default="scope">
                    <span>{{ scope.row.transferTime || '—' }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="status" label="审核状态" align="center" width="100">
                  <template #default="scope">
                    <span v-if="scope.row.status === 0">待审核</span>
                    <span v-else-if="scope.row.status === 1">审核失败</span>
                    <span v-else-if="scope.row.status === 2">审核成功</span>
                    <span v-else>{{ scope.row.status }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="createTime" label="创建时间" align="center">
                </el-table-column>
              </el-table>
              <el-pagination
                  @size-change="handleSizeChangeUser3"
                  @current-change="handleCurrentChangeUser3"
                  :page-sizes="[1,10, 20, 50, 100]"
                  :page-size="pageSizeThree"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="total"
                  class="pageList"/>
            </div>
          </el-tab-pane>

          <el-tab-pane label="暂存记录" name="five">

            <div class="search-box" style="margin-bottom: 20px; display: flex; align-items: center;">
              <span style="margin-right: 10px;">成果名称：</span>
              <el-input
                  v-model="achievementName"
                  placeholder="请输入成果名称进行查询"
                  clearable
                  style="width: 300px;"
              ></el-input>
              <!-- 查询按钮 -->
              <el-button type="primary" @click="getTemporarilyList(2)">查询</el-button>
              <!-- 重置按钮 -->
              <el-button @click="resetSearch(2)" style="margin-left: 10px;">重置</el-button>
            </div>
            <el-table :data="temporaryStorageList" border style="width: 100%">

              <el-table-column prop="createTime" label="日期" align="center">
              </el-table-column>
              <el-table-column prop="achievementName" label="成果名称" align="center">
              </el-table-column>
              <el-table-column prop="holdingUnit" label="持有单位/人" align="center">
              </el-table-column>
              <el-table-column prop="completionUnit" label="完成单位/人" align="center">
              </el-table-column>
              <el-table-column prop="phoneNumber" label="手机号" align="center">
              </el-table-column>
              <el-table-column label="操作" align="center" min-width="100">
                <template #default="scope">
                  <el-link
                      type="primary"
                      :underline="false"
                      @click="changeMessage(scope.row.id)"
                  >
                    修改
                  </el-link>
                  <br><br>
                  <div v-if="scope.row.isAchievement === 0 || scope.row.isAchievement === null">
                    <el-link
                        type="primary"
                        :underline="false"
                        @click="deleteTemporarilyById(scope.row.id)">
                      删除
                    </el-link>
                  </div>
                </template>
              </el-table-column>
            </el-table>

            <el-pagination
                @size-change="handleSizeChangeTemporary"
                @current-change="handleCurrentTemporary"
                :page-sizes="[1,10, 20, 50, 100]"
                :page-size="pageSizeFist"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
                class="pageList"/>
          </el-tab-pane>
        </el-tabs>
      </div>

    </el-card>

    <EvidenceDetailDialog
        :visible.sync="detailDialogVisible"
        :form="form"
    />

    <TransferFormDialog
        :visible.sync="showModal"
        :formzr="formzr"
        :form-rules="formRules"
        :current-transfer-type-list="currentTransferTypeList"
        :technical-manager-list="technicalManagerList"
        :area-code-array="areaCodeArray"
        :file-list="fileList"
        :showimg="showimg"
        @close="closeModal"
        @submit="homeviewSubmit"
        @area-code-change="updateAreaCode"
        @upload-success="onTransferUploadSuccess"
        @file-remove="onTransferFileRemove"
    />

    <!-- 修改手机号 -->
    <el-dialog title="修改手机号" :visible.sync="modifyPhoneDialogVisible" width="420px" append-to-body>
      <el-form :model="form" ref="modifyPhoneForm" label-width="88px">
        <el-form-item label="新手机号" prop="phoneNumber">
          <el-input v-model="form.phoneNumber" placeholder="请输入新手机号" maxlength="11" autocomplete="off"/>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="modifyPhoneDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitModifyPhone()">确 定</el-button>
      </div>
    </el-dialog>

  </div>
</template>
<script>

import {achievementTransfersList, confirmevidence, getInfo, queryViewDetails} from "@/api/login";
import {selectMarket, updateEvidence} from "@/api/certificate";
import {
  achievementTransfersListNotAdmin,
  evidenceById,
  temporarilyList,
  updateUserPhone,
  temporarilyById, deleteTemporarily
} from "@/api/http";
import { getUploadHeaders, UPLOAD_IMAGE_URL, UPLOAD_ACCEPT, beforeUploadAuth, openUploadedFile, resolveFileUrl, getFileBaseName } from "@/config/upload";
import { canDisposeAchievement, getAvailableTransferTypes, getExclusiveTransferDetail, getTransferDetail, formatTransferTypeLabel } from "@/utils/transferRights";
import TransferFormDialog from "@/components/TransferFormDialog.vue";
import EvidenceDetailDialog from "@/components/EvidenceDetailDialog.vue";

export default {
  components: {
    TransferFormDialog,
    EvidenceDetailDialog
  },
  computed: {
    uploadHeaders() {
      return getUploadHeaders()
    },
    phone() {
      return phone
    },
  },

  data() {
    return {
      UPLOAD_IMAGE_URL,
      UPLOAD_ACCEPT,
      beforeUploadAuth,
      showimg: '',
      imgList: [],
      isDisabled: true,
      modifyPhoneDialogVisible: false,
      userName: "",
      achievementTransfersList: [],
      showModal: false,
      fileList: [],
      detailDialogVisible: false,

      formzr: {
        receiveAccount: "",
        receiveMoney: "",
        achievementName: "",//成果名称
        id: "",
        userId: "",
        userName: "",
        loginId: "",
        uploadImg: "",//转让协议文件
        receiveName: "",//接收人名称
        receivePhone: "",//接收人电话
        transferType: "",//转让类型
        technicalManager: "", //技术经理人
        isAchievement: "",
        transferTime:"",
      },

      pageSizeThree: 10,
      pageNumThree: 1,
      pageSizeFist: 10,
      pageNumFirst: 1,
      achievementName: "",
      total: 0,
      pageSizeTwo: 10,
      pageNumTwo: 1,
      pageSize: 10,
      pageNum: 1,
      rights: [
        "自行实施转化",
        "科技成果转让",
        "科技成果许可",
        "合作实施转化",
        "科技成果作价投资",
        "其他",
      ],
      rightsP: [
        { value: 1, label: "自我估值" },
        { value: 2, label: "专家估值（委托专家评估)" }
      ],
      technicalFieldList: [
        "新一代信息技术产业",
        "高端装备制造产业",
        "新材料产业",
        "生物产业",
        "新能源汽车产业",
        "新能源产业",
        "节能环保产业",
        "数字创意产业",
        "相关服务业",
        "现代食品产业",
        "现代农林渔产业",
        "医药及医疗器械产业",
        "其他",
      ],
      form: {
        completePhoneNumber: "",//完成单位/人联系电话
        achievementName: "",//成果名称
        holdingUnit: "",//持有单位/人
        completionUnit: "",//完成单位/人
        phoneNumber: "", //联系电话
        completionTime: "",//完成时间
        introductionAchievements: "",//成果介绍
        coreTechnology: "",//核心技术
        marketProspect: "",//市场前景
        money: "",//金额
        //旧的
        depositSubject: "", // 存证主体
        isThirdParty: false, // 是否为第三方机构
        author: "", // 作者
        authorId: "", // 作者证件
        authorIdNumber: "", // 作者证件号码
        memberId: "", // 会员编号
        uploadFiles: "", // 上传文件
        depositName: "", // 存证名称
        depositType: "", // 存证类型
        equityOwnership: [], // 权益拥有
        originalFilenameUrl: "",//文件上传路径
        evaluationDocuments: "",//评估证书路径
        originalFilenameUrlName: "",//评估证书名
        conversionMethod: "",//转化方式
        //价值评估
        valueAssessment: "",
        //技术领域
        technicalField: "",
      },
      commissionTwoShow: false,
      detailDialogVisible: false,
      showAdmin: false,
      activeName: "first",
      // 个人信息
      userInfo: {
        name: "",
        email: "",
        phone: "",
        address: "",
        companyName: "",
        businessLicense: "",
        individual: 0,
      },
      formRules:{
        transferType: [
          { required: true, message: '请选择转让类型', trigger: 'blur' }
        ],
        // technicalManager: [
        //   { required: true, message: '请选择或输入技术经理人', trigger: 'blur' }
        // ],
        areaCodeval: [
          { required: true, message: '请选择所属区县', trigger: 'blur' }
        ],
        uploadImg: [ // 文件上传必填验证
          { required: true, message: '请上传转让协议', trigger: 'blur' }
        ]
      },
      areaCodeArray: [
        {value: 370902, name: "泰山区"},
        {value: 370911, name: "岱岳区"},
        {value: 370971, name: "高新区"},
        {value: 370983, name: "肥城市"},
        {value: 370982, name: "新泰市"},
        {value: 370921, name: "宁阳县"},
        {value: 370923, name: "东平县"},
        {value: -1, name: "其他地区"},
      ],
      transferTypeList: [
        {value: 0, label: "独家转让"},
        {value: 1, label: "非独家转让"},
        {value: 2, label: "成果许可"},
        {value: 3, label: "实施转化"},
        {value: 4, label: "作价投资"}
      ],
      currentTransferTypeList: [],
      // 待审核数据
      pendingReview: [],
      // 审核失败
      passReview: [],
      commissionShow: false,
      commissionList: [],
      commissionListTwo: [],
      // 审核成功数据
      underReview: [],
      //暂存列表
      temporaryStorageList: [],
      //技术经理人
      technicalManagerList: [],
    };

  },



  created() {
    // 组件创建时调用getUserInfo
    this.getuserInfo();
    this.getCheck(2);
    this.isAdmin();
    this.getTechnicalManager();
  },


  methods: {

    canDisposeAchievement,
    getExclusiveTransferDetail,
    getTransferDetail,
    getAvailableTransferTypes,
    formatTransferTypeLabel,

    openAgreementFile(path) {
      openUploadedFile(path);
    },

    getLicenseUrl(path) {
      return resolveFileUrl(path)
    },

    previewLicense() {
      if (this.userInfo.businessLicense) {
        openUploadedFile(this.userInfo.businessLicense)
      }
    },

    handleFileRemove(data) {
      const fileArray = this.form.originalFilenameUrl.split(',');
      // 2. 从数组中删除文件
      const file = this.form.uploadFiles.split(',');
      fileArray.splice(data.uid, 1); // 删除指定文件
      file.splice(data.uid, 1);
      // 3. 更新 originalFilenameUrl 为删除后的字符串
      this.form.originalFilenameUrl = fileArray.join(',');
      this.form.uploadFiles = file.join(',');
    },

    //存证文件
    handleUploadSuccess(data) {
      this.form.uploadFiles = this.form.uploadFiles ?
          this.form.uploadFiles + ',' + data.data.newName :
          data.data.newName
      //名字
      this.form.originalFilenameUrl = this.form.originalFilenameUrl ?
          this.form.originalFilenameUrl + ',' + data.data.originalFilename :
          data.data.originalFilename
    },
    determineUniqueness(files, fileList) {
      this.$message.warning('只能上传一次，请先移除现有的在上传新的文件');
    },

    beforeUpload(file) {
      // 你的上传前验证逻辑
      const isJPG = file.type === 'image/jpeg';
      const isPNG = file.type === 'image/png';
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!(isJPG || isPNG)) {
        this.$message.error('只能上传 JPG/PNG 格式图片！');
        return false;
      }
      if (!isLt2M) {
        this.$message.error('图片大小不能超过 2MB！');
        return false;
      }
      return true;
    },

    // 存证详情
    evidenceById(item) {
      evidenceById(item).then(res => {
        if (res.code !== 200 || !res.data) {
          this.$message.error('获取详情失败')
          return
        }
        this.form = res.data
        this.form.conversionMethod = res.data.conversionMethod
            ? res.data.conversionMethod.split(',')
            : []
        this.detailDialogVisible = true
      })
    },

    getFileUrl(filename) {
      return resolveFileUrl(filename)
    },

    getEvidenceFileLabel(path) {
      return getFileBaseName(path) || path || '—'
    },
//     //获取经理人协会数据
    getTechnicalManager() {
      selectMarket().then(res => {
        console.log("res", res);
        console.log("res.code", res.code);
        if (res.code === 200) {
          this.technicalManagerList = res.data
        }
      })
    },


    changeMessage(id) {
      this.$emit('updateMessage', id);
    },

    /** 修改存证并重新提交（仅审核失败/被退回可改） */
    editEvidence(row) {
      const status = Number(row.auditStatus)
      if (status === 2) {
        this.$message.warning('该成果已审核通过，如需修改请联系管理端退回后再操作')
        return
      }
      if (status === 0) {
        this.$message.warning('审核中的成果不可修改，请等待审核结果')
        return
      }
      if (status !== 1) {
        this.$message.warning('当前状态不可修改')
        return
      }
      this.$emit('changeMessage', row.id)
    },
    //根据id寻找暂存记录
    temporarilyById(id) {
      temporarilyById(id).then(res => {
        if (res.code === 200) {
          this.$emit('updateMessage', id)
        }
      })
    },
    //根据id删除暂存数据
    deleteTemporarilyById(id) {
      deleteTemporarily(id).then(res => {
        this.getTemporarilyList();
      })
    },
    //修改手机号
    submitModifyPhone() {
      var userId = localStorage.getItem("userId");
      let param = {
        userId: userId,
        userName: this.form.phoneNumber,
      }

      updateUserPhone(param).then(res => {
        if (res.code === 200) {
          //更新修改的内容
          this.getNewUserInfo();
          this.getuserInfo();
          this.form.phoneNumber = '';
          this.modifyPhoneDialogVisible = false;
          this.$message({
            message: '修改成功',
            type: 'success',
            duration: 3000,
            showClose: true,
            offset: 200
          })
        }
      })
    },

    buttonChange() {
      this.modifyPhoneDialogVisible = true;
      console.log("开启对话框")
    },

    //转化信息列表
    getAchievementList() {
      const params = {
        pageSize: this.pageSize,
        pageNum: this.pageNum,
        achievementName: this.achievementName
      }

      var userId = localStorage.getItem("userId");
      console.log(userId);
      if (this.showAdmin) {
        //alert("当前是管理员");
        //查全部
        achievementTransfersList(params).then(res => {
          console.log("user", res);
          this.userName = "";
          this.achievementTransfersList = res.rows;
          this.total = res.total
        })
      } else {
        const params = {
          pageSize: this.pageSize,
          pageNum: this.pageNum,
          fromUserId: userId,
          achievementName: this.achievementName
        }

        achievementTransfersListNotAdmin(params).then(res => {
          console.log(res);
          this.userName = "";
          this.achievementTransfersList = res.rows;
          this.total = res.total;
        })
      }
    },

    resetTransfer() {
      this.achievementName = '';
      this.pageNum = 1;
      this.getAchievementList();
    },

    onTransferUploadSuccess({ newName, fileList }) {
      this.formzr.uploadImg = newName;
      this.fileList = fileList;
    },
    onTransferFileRemove(fileList) {
      this.formzr.uploadImg = "";
      this.fileList = fileList;
    },

    homeviewSubmit() {
      var userId = localStorage.getItem("userId");
      console.log(userId);
      const loginData = {
        id: this.formzr.id,
        userId: this.formzr.userId,
        userName: this.formzr.userName,
        achievementName: this.formzr.achievementName,
        loginId: userId,
        receiveAccount: this.formzr.receiveAccount,
        receiveMoney: this.formzr.receiveMoney,
        uploadAgreementFile: this.formzr.uploadImg,
        receiveName: this.formzr.receiveName,
        receivePhone: this.formzr.receivePhone,
        areaCodeval: this.formzr.areaCodeval,
        technicalManager:this.formzr.technicalManager,
        transferType: this.formzr.transferType,
        transferTime:this.formzr.transferTime,
      };
      console.log("loginData",loginData);
      Object.assign(loginData, this.formrz);
      confirmevidence(loginData).then(res => {
        if (res.code === 200) {
          this.$message({
            message: '您的申请已提交，请耐心等待审核',
            type: 'success',
            duration: 3000,
            showClose: true,
            offset: 200
          })
          //清空内容
          this.cleanForm();
          this.showModal = false;
          this.getCheck(2);
        } else {
        }
      }).catch(err => {
        this.$message.error('提交异常')
      })
    },
    cleanForm() {
      this.formzr.receiveAccount = "";
      this.formzr.receiveMoney = "";
      this.formzr.achievementName = "";
      this.formzr.receiveName = "";
      this.formzr.receivePhone = "";
      this.formzr.transferType = "";
      this.formzr.technicalManager = "";
    },
    // 更新 form.areaCode 的值
    updateAreaCode(selectElement) {
      this.form.areaCodeval = selectElement;
    },
    closeModal() {
      this.showModal = false;
      this.fileList = [];
      this.formzr.uploadImg = "";
    },
    openModal(row) {
      this.currentTransferTypeList = getAvailableTransferTypes(this.transferTypeList, row || {});
      this.formzr.id = row.id;
      this.formzr.userId = row.userId;
      this.formzr.userName = row.userName;
      this.formzr.achievementName = row.achievementName;
      this.formzr.author = row.author;
      this.formzr.authorIdNumber = row.authorIdNumber;
      this.formzr.depositName = row.depositName;
      this.formzr.depositSubject = row.depositSubject;
      this.formzr.depositType = row.depositType;
      this.formzr.memberId = row.memberId;
      this.formzr.uploadFiles = row.uploadFiles;
      this.formzr.transferType = this.currentTransferTypeList.length
          ? this.currentTransferTypeList[0].value
          : 2;
      this.fileList = [];
      this.formzr.uploadImg = "";
      this.showModal = true;
    },
    resetSearch(item) {
      this.userName = ""
      this.achievementName = ""
      var userId = localStorage.getItem("userId");
      console.log("userId", userId);
      if (userId == null) {
        alert("请先登录");
      }
      if (item === 2) {
        this.pageNum = this.pageNumFirst
        this.pageSize = this.pageSizeFist
      } else if (item === 1) {
        this.pageNum = this.pageNumTwo
        this.pageSize = this.pageSizeTwo
      } else if (item === 0) {
        this.pageNum = this.pageNumThree
        this.pageSize = this.pageSizeThree
      }
      const data = {
        auditStatus: item,
        userId: userId,
        pageSize: this.pageSize,
        pageNum: this.pageNum,
        userName: this.userName
      }


      queryViewDetails(data).then(response => {
        console.log("item", item)
        if (item === 2) {
          this.passReview = response.rows
          this.total = response.total
          console.log("passReview", this.passReview)

        } else if (item === 1) {
          this.underReview = response.rows
          this.total = response.total
          console.log("underReview", this.underReview)
        } else if (item === 0) {
          this.pendingReview = response.rows
          this.total = response.total
        }
      })
    },

    filterByPhoneNumber(item) {
      var userId = localStorage.getItem("userId");

      if (userId === null) {
        alert("请先登录");
      }

      if (item === 2) {
        this.pageNum = this.pageNumFirst
        this.pageSize = this.pageSizeFist
      } else if (item === 1) {
        this.pageNum = this.pageNumTwo
        this.pageSize = this.pageSizeTwo
      } else if (item === 0) {
        this.pageNum = this.pageNumThree
        this.pageSize = this.pageSizeThree
      }

      const data = {
        auditStatus: item,
        userId: userId,
        pageSize: this.pageSize,
        pageNum: this.pageNum,
        userName: this.userName,
        achievementName: this.achievementName
      }

      queryViewDetails(data).then(response => {
        if (item === 2) {
          this.passReview = response.rows
          this.total = response.total
          console.log("passReview", this.passReview)
        } else if (item === 1) {
          this.underReview = response.rows
          this.total = response.total
          console.log("underReview", this.underReview)
        } else if (item === 0) {
          this.pendingReview = response.rows
          this.total = response.total
        }
      })
    },

    handleSizeChangeUser3(val) {
      this.pageSize = val
      const params = {
        pageSize: this.pageSize,
        pageNum: this.pageNum,
      }

      var userId = localStorage.getItem("userId");
      console.log(userId);
      if (this.showAdmin) {
        //alert("当前是管理员");
        console.log("当前是管理员");
        //查全部
        achievementTransfersList(params).then(res => {
          console.log(res);
          this.achievementTransfersList = res.rows;
          this.total = res.total
        })
      } else {
        const params = {
          pageSize: this.pageSize,
          pageNum: this.pageNum,
          fromUserId: userId
        }
        achievementTransfersListNotAdmin(params).then(res => {
          console.log(res);
          this.userName = "";
          this.achievementTransfersList = res.rows;
          this.total = res.total;
        })
      }
    },


    handleCurrentChangeUser3(item) {
      console.log("item", item)
      const params = {
        pageSize: this.pageSize,
        pageNum: item,
      }
      var userId = localStorage.getItem("userId");
      console.log(userId);
      if (this.showAdmin) {
        //alert("当前是管理员");
        console.log("当前是管理员");
        //查全部
        achievementTransfersList(params).then(res => {
          console.log(res);
          this.achievementTransfersList = res.rows;
          this.total = res.total
        })
      } else {
        const params = {
          pageSize: this.pageSize,
          pageNum: item,
          fromUserId: userId
        }
        achievementTransfersListNotAdmin(params).then(res => {
          console.log(res);
          this.userName = "";
          this.achievementTransfersList = res.rows;
          this.total = res.total;
        })
        // alert("当前不是管理员");
        //查转让人或接收人是自己的数据
      }
    },


    handleSizeChangeThree(val) {
      this.pageSizeThree = val;
      var userId = localStorage.getItem("userId");
      console.log("userId", userId);
      if (userId == null) {
        alert("请先登录");
      }
      const data = {
        auditStatus: 0,
        userId: userId,
        pageSize: this.pageSizeThree,
        pageNum: this.pageNumThree,
        userName: this.userName,
        achievementName: this.achievementName
      }
      queryViewDetails(data).then(response => {
        this.pendingReview = response.rows
        this.total = response.total
      })

    },
    handleCurrentChangeThree(val) {
      this.pageNumThree = val;
      var userId = localStorage.getItem("userId");
      console.log("userId", userId);
      if (userId == null) {
        alert("请先登录");
      }
      const data = {
        auditStatus: 0,
        userId: userId,
        pageSize: this.pageSizeThree,
        pageNum: this.pageNumThree,
        userName: this.userName,
        achievementName: this.achievementName
      }
      queryViewDetails(data).then(response => {
        this.pendingReview = response.rows
        this.total = response.total
      })
    },
    handleSizeChangeTwo(val) {
      this.pageSizeTwo = val;
      var userId = localStorage.getItem("userId");
      console.log("userId", userId);
      if (userId == null) {
        alert("请先登录");
      }
      const data = {
        auditStatus: 1,
        userId: userId,
        pageSize: this.pageSizeTwo,
        pageNum: this.pageNumTwo,
      }
      queryViewDetails(data).then(response => {
        this.underReview = response.rows
        this.total = response.total
      })

    },
    handleCurrentChangeTwo(val) {
      this.pageNumTwo = val;
      var userId = localStorage.getItem("userId");
      console.log("userId", userId);
      if (userId == null) {
        alert("请先登录");
      }
      const data = {
        auditStatus: 1,
        userId: userId,
        pageSize: this.pageSizeTwo,
        pageNum: this.pageNumTwo,
        userName: this.userName,
        achievementName: this.achievementName
      }
      queryViewDetails(data).then(response => {
        this.underReview = response.rows
        this.total = response.total
      })
    },

    handleSizeChangeFirst(val) {
      this.pageSizeFist = val;
      var userId = localStorage.getItem("userId");
      console.log("userId", userId);
      if (userId == null) {
        alert("请先登录");
      }
      const data = {
        auditStatus: 2,
        userId: userId,
        pageSize: this.pageSizeFist,
        pageNum: this.pageNumFirst,
        userName: this.userName,
        achievementName: this.achievementName
      }
      queryViewDetails(data).then(response => {
        this.passReview = response.rows
        this.total = response.total
      })
    },

    handleCurrentChangeFirst(val) {
      this.pageNumFirst = val;
      var userId = localStorage.getItem("userId");
      if (userId == null) {
        alert("请先登录");
      }
      const data = {
        auditStatus: 2,
        userId: userId,
        pageSize: this.pageSizeFist,
        pageNum: this.pageNumFirst,
        userName: this.userName,
        achievementName: this.achievementName
      }
      queryViewDetails(data).then(response => {
        this.passReview = response.rows
        this.total = response.total
      })
    },
    viewContent(data) {
      const filePath = data.evaluateSupportingMaterials
      if (filePath) {
        openUploadedFile(filePath)
      } else {
        console.log("list", data.commissionList)
        this.commissionList = data.commissionList[0];
        this.commissionShow = true;
      }
    },
    rightText(right) {
      return right.replace("（查看)", "");
    },
    openUrl(url) {
      window.open(url)
    },
    async handleDownload(row) {
      // 设置下载状态
      window.location.href = 'https://kejichengguo.tskjdsc.com/dev-api/evidence/download/' + row.id
    },
    handleApprove(row) {
      console.log(row)
      const data =
          {
            id: row.id,
            auditStatus: 2
          };
      updateEvidence(data)
          .then(responses => {
            this.$message({
              message: '该审核已通过',
              type: 'success',
              duration: 3000,
              showClose: true,
              offset: 300
            })
            this.getCheck(0);
          });
    },

    handleReject(row) {
      const data = {
        id: row.id,
        auditStatus: 1
      }
      updateEvidence(data).then(res => {
        this.$message({
          message: '审核已拒绝',
          type: 'error',
          duration: 3000,
          showClose: true
        })
        this.getCheck(0)  // 假设你有一个获取列表数据的方法
      })
    },
    isAdmin() {
      const token = localStorage.getItem('token');
      const userId = localStorage.getItem("userId");
      if (userId === '1') {
        this.showAdmin = true
        console.log("1")
      } else {
        this.showAdmin = false
      }

    },
    getNewUserInfo() {
      var token = localStorage.getItem("token");
      console.log("token", token);
      getInfo(token).then(response => {
        sessionStorage.setItem("userId", response.data.user.userId);
        localStorage.setItem("userId", response.data.user.userId);
        var userId = sessionStorage.getItem("userId");
        console.log("userId", userId);
        var userJson = JSON.stringify(response.data.user);
        sessionStorage.setItem("userInfos", userJson);
        localStorage.setItem("userInfos", userJson);
        var userInfos = sessionStorage.getItem("userInfos");
        // var userInfos = localStorage.getItem("userInfos");
        // 将JSON字符串解析回对象，并赋值给组件的data属性
        var userInfoObj = JSON.parse(userInfos);
        // 正确的赋值方式
        this.userInfo.name = userInfoObj.userName; // 注意这里是赋值，不是函数调用
        this.userInfo.email = userInfoObj.email;
        this.userInfo.phone = userInfoObj.phonenumber; // 注意这里应该是phonenumber，而不是email
        this.userInfo.companyName = userInfoObj.companyName;
        this.userInfo.businessLicense = userInfoObj.businessLicense;
        this.userInfo.individual = userInfoObj.individual;
      }).catch(error => {
        console.error("请求失败", error);
      });
    },
    //个人信息
    getuserInfo() {
      var userInfos = localStorage.getItem("userInfos");
      // 将JSON字符串解析回对象，并赋值给组件的data属性
      var userInfoObj = JSON.parse(userInfos);
      // 正确的赋值方式
      this.userInfo.name = userInfoObj.userName;
      this.userInfo.email = userInfoObj.email;
      this.userInfo.phone = userInfoObj.phonenumber;
      this.userInfo.companyName = userInfoObj.companyName;
      this.userInfo.businessLicense = userInfoObj.businessLicense;
      this.userInfo.individual = userInfoObj.individual;
    },
    /**
     * 选择tab定位
     * @param tab
     * @param event
     */
    handleClick(tab, event) {
      if (tab.index === "0") {
        this.getCheck("2");
      } else if (tab.index === "1") {
        this.getCheck("1");
      } else if (tab.index === "2") {
        console.log("zou")
        this.getCheck("0");
      } else if (tab.index === "3") {
        this.getAchievementList();
      } else if (tab.index === '4') {
        this.getTemporarilyList();
      }
    },

    //获取暂存数据
    getTemporarilyList() {
      const userId = localStorage.getItem("userId");
      const param = {
        userId: userId,
        achievementName: this.achievementName
      };

      temporarilyList(param).then(res => {
        if (res.code === 200) {
          this.temporaryStorageList = res.rows;
          this.total = res.total
        }
      })
    },

    getCheck(status) {
      //获取审核信息
      var userId = localStorage.getItem("userId");
      console.log("userId", userId);
      console.log("status", status);
      if (userId == null) {
        alert("请先登录");
      }
      if (status === "2") {
        this.pageNum = this.pageNumFirst
        this.pageSize = this.pageSizeFist
      } else if (status === "1") {
        this.pageNum = this.pageNumTwo
        this.pageSize = this.pageSizeTwo
      } else if (status === "0") {
        this.pageNum = this.pageNumThree
        this.pageSize = this.pageSizeThree
      }
      const data = {
        auditStatus: status,
        userId: userId,
        pageNum: this.pageNum,
        pageSize: this.pageSize
      }
      queryViewDetails(data).then(response => {
        console.log("queryViewDetails", status)
        let statusString = status.toString();
        if (statusString === '2') {
          this.passReview = response.rows
          this.total = response.total
          console.log("passReview", this.passReview)

        } else if (statusString === '1') {
          this.underReview = response.rows
          this.total = response.total
          console.log("underReview", this.underReview)
        } else if (statusString === '0') {
          this.pendingReview = response.rows
          this.total = response.total
        }
      }).catch(error => {
        console.error("请求失败", error);
      });
    },
    handleSizeChangeTemporary(val){
      const userId = localStorage.getItem("userId");
      this.pageSize = val;
      const params = {
        pageSize: val,
        pageNum: this.pageNum,
        userId:userId
      }
      temporarilyList(params).then(res => {
        if (res.code === 200) {
          this.temporaryStorageList = res.rows
          this.total = res.total
        }
      })
    },
    handleCurrentTemporary(val){
      const userId = localStorage.getItem("userId");
      this.pageNum = val;
      const params = {
        pageSize: this.pageSize,
        pageNum: val,
        userId:userId
      }

      temporarilyList(params).then(res => {
        if (res.code === 200) {
          this.temporaryStorageList = res.rows
          this.total = res.total
        }
      })
    },
  },
};
</script>

<style scoped lang='scss'>

::v-deep(.el-upload-dragger) {
  width: 450px !important;
}
.buttonChange {
  cursor: pointer;
  color: #0077ff;
  margin-left: 50px;
}

.close {
  color: #aaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
}

.close:hover,
.close:focus {
  color: black;
  text-decoration: none;
  cursor: pointer;
}

.clickable {
  color: #0077ff;
  cursor: pointer;
  //text-decoration: underline;
}

::v-deep .el-message {
  height: 80px !important;
}

.container {
  margin: 0 auto;
  padding: 20px;
}

.personal-info,
.review-section {
  margin-bottom: 30px;
  padding: 15px;
  border: 1px solid #ccc;
  border-radius: 5px;
}

h2 {
  color: #333;
  margin-bottom: 10px;
}

h3 {
  color: #666;
  margin-bottom: 8px;
}

.info p,
.review-category p {
  margin: 5px 0;
  text-align: left;
}

.review-category {
  margin-top: 20px;
}

.info p {
  margin-bottom: 16px;
  font-size: 16px;
}

.userInfo {
  margin-bottom: 24px;
}

.account-card {
  border-radius: 8px;
  overflow: hidden;

  ::v-deep .el-card__header {
    padding: 14px 20px;
    background: linear-gradient(135deg, #f8fafc 0%, #ffffff 100%);
    border-bottom: 1px solid #ebeef5;
  }

  ::v-deep .el-card__body {
    padding: 0;
  }
}

.account-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;

  h2 {
    margin: 0;
    font-size: 17px;
    font-weight: 600;
    color: #303133;
  }
}

.account-info-body {
  border-top: none;
}

.account-info-row {
  display: flex;
  align-items: stretch;
  min-height: 52px;
  border-bottom: 1px solid #ebeef5;

  &:last-child {
    border-bottom: none;
  }
}

.account-info-row-license {
  align-items: stretch;

  .account-info-label {
    padding-top: 18px;
  }
}

.account-info-label {
  flex: 0 0 112px;
  width: 112px;
  padding: 14px 16px;
  background: #fafbfc;
  color: #606266;
  font-size: 14px;
  font-weight: 500;
  border-right: 1px solid #ebeef5;
  display: flex;
  align-items: center;
  box-sizing: border-box;
}

.account-info-content {
  flex: 1;
  min-width: 0;
  padding: 14px 20px;
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  background: #fff;
}

.account-info-value {
  font-size: 15px;
  color: #303133;
  word-break: break-all;
  line-height: 1.5;
}

.account-info-empty {
  color: #c0c4cc;
  font-size: 14px;
}

.account-action-btn {
  padding: 0;
  font-size: 13px;
  margin-left: auto;
}

.account-license-box {
  display: flex;
  align-items: center;
  gap: 16px;
  width: 100%;
  flex-wrap: wrap;

  .account-action-btn {
    margin-left: 0;
  }
}

.account-license-preview {
  flex-shrink: 0;
  padding: 6px;
  border: 1px solid #e4e7ed;
  border-radius: 8px;
  background: #fafafa;
  cursor: pointer;
  transition: border-color 0.2s, box-shadow 0.2s;

  &:hover {
    border-color: #409eff;
    box-shadow: 0 2px 12px rgba(64, 158, 255, 0.15);
  }
}

.account-license-img {
  display: block;
  width: 160px;
  height: 100px;
  object-fit: contain;
  border-radius: 4px;
}

@media (max-width: 768px) {
  .account-info-row {
    flex-direction: column;
    min-height: auto;
  }

  .account-info-label {
    width: 100%;
    flex: none;
    border-right: none;
    border-bottom: 1px solid #ebeef5;
    padding: 10px 16px;
  }

  .account-info-content {
    padding: 12px 16px;
  }

  .account-action-btn {
    margin-left: 0;
  }
}

.itemBox {
  position: relative;
  padding: 20px;
  min-height: 250px;
  //height: 400px;
  //overflow-y: auto;
  .item {
    margin-bottom: 20px;
    font-size: 16px;

    .item_info {
      display: flex;
    }
  }

  .empty {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
  }

  .noData {
    width: 200px;
  }
}

.el-message-box {
  padding: 20px;
  border-radius: 4px;
}

.el-message-box__header {
  padding: 15px !important;
}

.el-message-box__title {
  font-size: 16px !important;
  color: #333 !important;
}

.el-message-box__content {
  padding: 20px !important;
}

.el-message-box__btns {
  padding: 10px 20px 20px !important;
}

.el-button {
  margin: 0 10px !important;
}

.radio-option {
  font-size: 16px;
}

.el-message--success {
  font-size: 20px;
  margin-bottom: 20%;
}

.el-message-box__header {
  .button {
    display: none !important;
  }
}

.custom-buttonPass {
  padding: 9px 15px;
  font-size: 12px;
  //border-radius: 3px;
  color: #FFF;
  background-color: #409EFF;
  border-color: #409EFF;
}

.custom-buttonRefuse {
  padding: 9px 15px;
  font-size: 12px;
  //border-radius: 3px;
  color: #FFF;
  background-color: #ff405d;
  border-color: #ff405d;
  margin-top: 5px;
}

.returnClass {
  font-size: 20px;
  margin-bottom: 10px;
  cursor: pointer;
  align-items: center;
}

.icon {
  width: 40px;
  height: 40px;
}

.clearfixRight {
  cursor: pointer;
}

.pageList {
  margin-top: 30px;
  /* align-content: center; */
  display: flex;
  justify-content: center;
}

.returnSpanClass {
  height: 40px;
  align-items: center;
  margin-top: 20px;
  margin-left: 10px;
}

.returnClass {
  font-size: 20px;
  margin-bottom: 10px;
  cursor: pointer;
  align-items: center;
  display: flex;
}

/* 设置下拉选项框的最大高度和滚动条 */
.el-select-dropdown__wrap {
  max-height: 300px !important;  /* 设置最大高度 */
  overflow-y: auto !important;   /* 启用垂直滚动 */
}

/* 可选：美化滚动条 */
.el-select-dropdown__wrap::-webkit-scrollbar {
  width: 6px;
}
.el-select-dropdown__wrap::-webkit-scrollbar-thumb {
  background-color: #c1c1c1;
  border-radius: 3px;
}

.transfer-detail-cell {
  text-align: left;
  line-height: 1.6;
  font-size: 12px;
  color: #606266;
  padding: 4px 0;
}

.transfer-detail-pending {
  color: #e6a23c;
  font-weight: 600;
  margin-bottom: 4px;
}

.search-box {
  display: flex;
  align-items: center;
  gap: 20px;
  margin-bottom: 20px;
  padding: 15px;
  background: #f8f9fa;
  border-radius: 8px;

  .search-item {
    display: flex;
    align-items: center;
    gap: 8px;

    label {
      font-weight: 500;
      color: #333;
      white-space: nowrap;
    }
  }

  .search-buttons {
    display: flex;
    gap: 10px;
  }
}

@media (max-width: 768px) {
  .search-box {
    flex-direction: column;
    align-items: stretch;

    .search-item {
      justify-content: space-between;
    }
  }
}

</style>
